import AppLayout from "@/layouts/AppLayout";
import { useUniversityNavLinks } from "@/pages/education/universities/[universityId]/_universityNav";
import { Outlet, useParams } from "react-router-dom";
import UniversityHeading from "../_layouts/UniversityHeading";
import { useQuery } from "@apollo/client";
import { UNIVERSITY_QUERY } from "../queries";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function UniversityStaffLayout() {
  const { universityId } = useParams();
  const { isCompactLayout } = useIsCompactLayout();
  const navLinks = useUniversityNavLinks(universityId!);

  const { data: universityData } = useQuery(UNIVERSITY_QUERY, {
    variables: { legacyId: universityId },
    skip: !universityId,
    errorPolicy: "all"
  });

  const university = universityData?.universities[0];

  const renderDesktopLayout = () => (
    <>
      <UniversityHeading
        universityName={university?.name || ""}
        logoUrl={university?.logoUrl}
        activeStudentCount={university?.activeStudentCount}
        alumniStudentCount={university?.alumniStudentCount}
        studentProgramSummary={university?.studentProgramSummary}
      />
      <Outlet />
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Staff"
        backLink={{ to: "/education/universities/:universityId", params: { universityId: universityId! } }}
      />
      <UniversityHeading
        universityName={university?.name || ""}
        logoUrl={university?.logoUrl}
        activeStudentCount={university?.activeStudentCount}
        alumniStudentCount={university?.alumniStudentCount}
        studentProgramSummary={university?.studentProgramSummary}
      />
      <Outlet />
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isCompactLayout ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
